import loginSlider1 from "../assets/images/login/slider1.jpg";
import loginSlider2 from "../assets/images/login/slider2.jpg";
import loginSlider3 from "../assets/images/login/slider3.jpg";
import loginSlider4 from "../assets/images/login/slider4.jpg";
import logo from "../assets/images/logo.png";
import forgotPassword from "../assets/images/forgot.png";
import circle from "../assets/images/circle.svg";
import contactUs from "../assets/images/contact.png";
import profile from "../assets/images/profile.png";
import noAccount from "../assets/images/noAccount.png";
import noData from "../assets/images/no-data.png";
import instagram from "../assets/images/insta.png";
import tikTok from "../assets/images/tik-tok.png";
import youtube from "../assets/images/youtube.png";
import product1 from "../assets/images/product/img.png";
import product2 from "../assets/images/product/img2.png";
import product3 from "../assets/images/product/img3.png";
import product4 from "../assets/images/product/img4.png";
import card1 from "../assets/images/card1.jpg";
import card2 from "../assets/images/card2.jpg";
import card3 from "../assets/images/card3.jpg";
import contacts from "../assets/images/Brand/contact.png";
import insight from "../assets/images/Brand/insight.png";
import threeDots from "../assets/images/menu.png";
import defUser from "../assets/images/def-user.png";
import wallet from "../assets/images/wallet.png";
import money from "../assets/images/money.png";
import speaker from "../../src/assets/images/speaker.png";
import mobileFilter from "../../src/assets/images/mobile-filter.png";

const Images = {
  insight,
  mobileFilter,
  speaker,
  defUser,
  contacts,
  threeDots,
  card1,
  card2,
  card3,
  wallet,
  noData,
  money,
  instagram,
  tikTok,
  youtube,
  noAccount,
  profile,
  product1,
  product2,
  product3,
  product4,
  circle,
  contactUs,
  forgotPassword,
  loginSlider1,
  loginSlider2,
  loginSlider3,
  loginSlider4,
  logo,
};
export default Images;
